export default function isProduction() {
  if (typeof window === 'undefined') {
    return false
  }
  const { location: { hostname } } = window
  if (/localhost/.test(hostname) || /playground/.test(hostname)) {
    return false
  }
  return true
}
